function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useRef, useState } from "react";
export var useHover = function useHover() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setHovering = _useState2[1];

  var hoverActions = {
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    }
  };
  return {
    hoverActions: hoverActions,
    isHovering: isHovering,
    setHovering: setHovering
  };
};
export default useHover;
export var useDelayedHover = function useDelayedHover(isHovering) {
  var _useState3 = useState(isHovering),
      _useState4 = _slicedToArray(_useState3, 2),
      delayedHovering = _useState4[0],
      setDelayedHovering = _useState4[1];

  var timeoutIdRef = useRef(null);
  useEffect(function () {
    if (isHovering) {
      clearTimeout(timeoutIdRef.current);
      setDelayedHovering(true);
    } else {
      // Clear any existing timeout and start a new one
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(function () {
        setDelayedHovering(false);
      }, 200);
    }

    return function () {
      return clearTimeout(timeoutIdRef.current);
    };
  }, [isHovering]);
  return delayedHovering;
};
export var useIsHovered = function useIsHovered(element) {
  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isHovered = _useState6[0],
      setIsHovered = _useState6[1];

  useEffect(function () {
    if (!element) return;

    var handleMouseOver = function handleMouseOver(event) {
      if (element.contains(event.target)) {
        setIsHovered(true);
      }
    };

    var handleMouseOut = function handleMouseOut(event) {
      if (!element.contains(event.relatedTarget)) {
        setIsHovered(false);
      }
    };

    element.addEventListener("mouseover", handleMouseOver);
    element.addEventListener("mouseout", handleMouseOut);
    return function () {
      element.removeEventListener("mouseover", handleMouseOver);
      element.removeEventListener("mouseout", handleMouseOut);
    };
  }, [element]);
  return isHovered;
};